module.exports = __webpack_public_path__ + "img/img17.6b7e437e.jpg";